"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var defaultTableTheme = {
    Table: {},
    TableBody: function (_a) {
        var theme = _a.theme;
        return ({
            fontFamily: theme.typography.fontFamily,
            color: theme.palette.text.primary,
            fontSize: theme.typography.body2.fontSize,
            fontWeight: theme.typography.fontWeightRegular,
            backgroundColor: theme.palette.common.white,
            textAlign: 'left'
        });
    },
    TableRow: {
        backgroundColor: 'inherit'
    },
    TableCell: function (_a) {
        var theme = _a.theme;
        return ({
            height: 40,
            overflowY: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            padding: theme.spacing(0, 2),
            borderBottom: "1px solid " + theme.palette.grey[300],
            verticalAlign: 'middle',
            backgroundColor: 'inherit'
        });
    },
    TableFooter: function (_a) {
        var theme = _a.theme;
        return ({
            fontFamily: theme.typography.fontFamily,
            color: theme.palette.common.white,
            fontSize: theme.typography.body2.fontSize,
            fontWeight: theme.typography.fontWeightMedium,
            backgroundColor: theme.palette.primary.main,
            textAlign: 'right'
        });
    },
    TableFooterRow: {
        backgroundColor: 'inherit'
    },
    TableFooterCell: function (_a) {
        var theme = _a.theme;
        return ({
            height: 20,
            overflowY: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            padding: theme.spacing(1, 2),
            borderBottom: "1px solid " + theme.palette.grey[300],
            verticalAlign: 'middle',
            backgroundColor: '#eeeeee',
            position: 'sticky',
            bottom: 0,
            zIndex: 1
        });
    },
    TableHeader: function (_a) {
        var theme = _a.theme;
        return ({
            fontFamily: theme.typography.fontFamily,
            color: theme.palette.text.secondary,
            fontSize: theme.typography.caption.fontSize,
            fontWeight: theme.typography.fontWeightMedium,
            backgroundColor: theme.palette.common.white,
            zIndex: 1300
        });
    },
    TableHeaderRow: {
        backgroundColor: 'inherit'
    },
    TableHeaderCell: function (_a) {
        var theme = _a.theme;
        return ({
            height: 'auto',
            overflowY: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            padding: theme.spacing(2, 2, 1, 2),
            borderBottom: "1px solid " + theme.palette.grey[300],
            verticalAlign: 'middle',
            backgroundColor: 'inhert',
            position: 'sticky',
            top: 0,
            fontSize: '0.8125rem'
        });
    }
};
exports.default = defaultTableTheme;
